import { FC, useContext, useEffect } from 'react';
import { AlertContext } from '../../context/AlertProvider';
import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { AlertType } from '../../types/enums';
import { defaultErrorText } from '../../types/Error/ErrorResponseType';
import { homeRoutesURLs } from '../../constants/routes';
import { captureApiError, setSentryUser } from '../../instrument';

type AxiosInterceptorProps = {
  setIsAuthenticated: (status: boolean) => void;
};

const AxiosInterceptor: FC<AxiosInterceptorProps> = ({ setIsAuthenticated }) => {
  const { setAlert } = useContext(AlertContext);
  const navigate = useNavigate();

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error instanceof AxiosError) {
          const resolvedMessage = String(
            error.response?.data?.message ?? error?.message ?? '',
          ).trim();
          setAlert({
            type: AlertType.Error,
            message: resolvedMessage || defaultErrorText
          });
        } else {
          setAlert({ type: AlertType.Error, message: defaultErrorText });
        }

        const status = error.response?.status;
        if (typeof status === 'number' && status >= 500) {
          captureApiError(error);
        }

        if (401 === error.response?.status) {
          setIsAuthenticated(false);
          localStorage.removeItem('user');
          localStorage.removeItem('workplace');
          setSentryUser(null);
          navigate(homeRoutesURLs.loginPagePath);
          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, []);

  return null;
};

export default AxiosInterceptor;
